import client from '../../client';
import {
  AUTHENTICATE,
  AUTHENTICATE_SUCCESS,
  AUTHENTICATE_FAIL,
  WS_AUTHENTICATED,
  SET_PAYLOAD
} from '../constants/auth';
import config from '../../config';

export const authenticate = () => dispatch => {
  dispatch({
    type: AUTHENTICATE
  });

  client
    .get('/auth/test')
    .then(res => {
      dispatch({
        type: AUTHENTICATE_SUCCESS,
        data: res.data.user
      });
      dispatch({
        type: WS_AUTHENTICATED,
        data: {...res.data.user, currentLocation: window.location.pathname }
      })
    })
    .catch(err => {
      dispatch({
        type: AUTHENTICATE_FAIL
      })
    });
}

export const setPayload = (payload) => dispatch => {
  dispatch({
    type: SET_PAYLOAD,
    data: payload
  })
}

export const logout = () => dispatch => {
  window.localStorage.removeItem('jwt');
  window.location.href = config.signoutURL;
}



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js